import styled from 'styled-components'

export const SubTitle = styled.p`
  color: ${({ theme }) => theme.cor66};
  font-size: 16px;
  margin: 0;
`

export const CheckboxAndRadioWrapper = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 20px;

  .mantine-Radio-label {
    font-weight: 400;
  }
`

export const BotoesWrapper = styled.div`
  display: flex;
  margin-top: 30px;
  gap: 10px;

  button {
    width: 50%;
  }
`
